module.exports = __webpack_public_path__ + "static/media/check-box-ic-disabled.72a460b2.svg";